import { useNoticeToast } from "@/lib/noticeToastStore";

export function NoticeToast() {
  const message = useNoticeToast((state) => state.message);
  const dismiss = useNoticeToast((state) => state.dismiss);
  if (!message) return null;
  return (
    <div className="archive-toast notice-toast" role="status" aria-live="polite">
      <span>{message}</span>
      <button type="button" className="archive-toast-close" onClick={dismiss} aria-label="Dismiss">×</button>
    </div>
  );
}
